<template>
  <div class="center-content">
    <h2>{{ $t("project.modulationComponent.title") }}</h2>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "ProjectModulationComponent",
  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>

<style scoped>
.center-content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-size: 1.5rem;
}
</style>
